export default {
  // props: ["id", "index", "value"],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    backLast: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isShowSlide: false // 是否显示配置页面
    };
  },
  methods: {
    handleBack: function handleBack() {
      this.$emit('update:show', false);
      if (this.backLast) {
        return;
      } else {
        if (window.frameParent) {
          window.frameParent.call('setDesignId');
        }
      }
    }
  }
};